import React from "react";
import { SEMANTIC, SEMANTIC_DOT } from "@/lib/meta";

export function Badge({ color = "grey", children, dot = false, className = "", ...props }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium ${SEMANTIC[color] || SEMANTIC.grey} ${className}`}
      {...props}
    >
      {dot && <span className={`h-1.5 w-1.5 rounded-full ${SEMANTIC_DOT[color] || SEMANTIC_DOT.grey}`} />}
      {children}
    </span>
  );
}

export function Bar({ value = 0, color = "blue", className = "" }) {
  const w = Math.max(0, Math.min(100, Math.round(value * 100)));
  const bar = {
    green: "bg-emerald-500",
    orange: "bg-amber-500",
    red: "bg-red-500",
    blue: "bg-blue-500",
    grey: "bg-zinc-400",
  }[color] || "bg-blue-500";
  return (
    <div className={`h-2 w-full overflow-hidden rounded-full bg-zinc-100 ${className}`}>
      <div className={`h-full rounded-full transition-all duration-500 ${bar}`} style={{ width: `${w}%` }} />
    </div>
  );
}
